import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../../models/template/type.enum';
import { rsaBlocksForSelect } from '../../../../../utils/blocks-helper';
import { TemplateEditorComponent } from '../../../base-template-editor/template-editor.component';
import { BlockMaximumCount } from '../../../../../models/template/block-maximum-count.interface.';
import { BlockMinimumCount } from '../../../../../models/template/block-minimum-count.interface';
import { UniqueTextConstraint } from '../../../../../models/template/unique-text-constraint.interface';
import { RequiredFieldConstraint } from '../../../../../models/template/required-field-constraint.interface';

@Component({
    selector: 'app-rsa-search-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/rsa-search-template/"
      channelLabel="Google RSA Search"
      namePlaceholder="Enter Google RSA Search template name"
      emptyMessage="No Google RSA Search template found!"
      heartbeatType="rsa-search-template"
      [enableBlockToolbar]="true"
      [showSidePreview]="true"
      [blockCatalog]="blockCatalog"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks"
      [blockMaximumCount]="blockMaximumCount"
      [blockMinimumCount]="blockMinimumCount"
      [uniqueTextConstraints]="uniqueTextConstraints"
      [requiredFields]="requiredFields"
      />
  `
})
export class RsaSearchTemplateComponent {
  protected readonly templateType = TypeEnum.GOOGLE_RSA_SEARCH;
  protected readonly blockCatalog = rsaBlocksForSelect;

  protected readonly blockMaximumCount: BlockMaximumCount[] = [
    { blockName: "sitelink", limit: 20 },
    { blockName: "rsa-search-image", limit: 1 },
    { blockName: "rsa-search-callouts", limit: 1 },
  ];

  protected readonly blockMinimumCount: BlockMinimumCount[] = [
    { blockName: "sitelink", treshold: 4 },
  ];

  protected readonly uniqueTextConstraints: UniqueTextConstraint[] = [
    { blockName: 'sitelink', fields: ['Text'] },
    { blockName: 'headline', fields: ['Headline_'] },
    { blockName: 'description', fields: ['Description_'] },
  ];

  // Image upload and dropdowns have no editor for the empty-field check to see.
  // Both blocks are optional add-ons, so they are only checked once added.
  protected readonly requiredFields: RequiredFieldConstraint[] = [
    { blockName: 'rsa-search-image', field: 'GoogleRsaSearchImage_', label: 'Image' },
    { blockName: 'rsa-search-calls', field: 'Country', label: 'Calls country' },
  ];

  // Order matters — mirrors the original push order for new templates.
  // `count` sets the starting instance index; omit it and it auto-increments per name.
  protected readonly defaultBlocks: { name: string; count?: number; variables: Record<string, string> }[] = [
    { name: 'rsa-search-final-url', count: 1, variables: { Link: '' } },
    {
      name: 'rsa-search-display-path',
      count: 1,
      variables: { FirstPart: '', SecondPart: '' },
    },
    {
      name: 'headline',
      count: 1,
      variables: { Headline_1: '', Headline_2: '', Headline_3: '' },
    },
    { name: 'description', count: 1, variables: { Description_1: '', Description_2: '' } },
    { name: 'sitelink', count: 1, variables: { Text: '', FirstDescriptionLine: '', SecondDescriptionLine: '', SitelinkLink: '' } },
    { name: 'sitelink', count: 2, variables: { Text: '', FirstDescriptionLine: '', SecondDescriptionLine: '', SitelinkLink: '' } },
    { name: 'sitelink', count: 3, variables: { Text: '', FirstDescriptionLine: '', SecondDescriptionLine: '', SitelinkLink: '' } },
    { name: 'sitelink', count: 4, variables: { Text: '', FirstDescriptionLine: '', SecondDescriptionLine: '', SitelinkLink: '' } },
  ];
}
